export interface NetworkLookup {
  network: string,
  country: string
}